<div cdkTrapFocus [attr.aria-modal]="true" data-target="noInternet">
  <article class="dt-l-article">
    <div class="dt-l-article__content">
      <div class="dt-l-article__section__logo">
        <img [attr.alt]="'UI_COMPANY_LOGO' | translate" src="assets/img/logo-default.png" />
      </div>

      <section class="dt-l-article__section">
        <h1 class="dt-l-article__section__title" tabindex="-1">
          {{ 'BAD_CONNECTION' | translate }}
        </h1>
        <p class="dt-l-article__section__description">
          {{ 'BAD_CONNECTION_TEXT' | translate }}
        </p>
        <div class="dt-l-button-group">
          <button type="button" class="dt-c-button primary" (click)="retry()">
            {{ 'RETRY' | translate }}
          </button>
        </div>
      </section>
    </div>
  </article>
</div>
